import React from "react";
import s from "./AddAnnouncement.module.scss";
import Header from "../../components/Header/Header";
import { Tabs } from "antd";
import Footer from "../../components/Footer/Footer";

import TabPane from "antd/es/tabs/TabPane";
import { CarOutlined, ToolOutlined, UserAddOutlined } from "@ant-design/icons";
import AddCar from "../AddCar/AddCar";
import AddSpares from "../AddSpares/AddSpares";
import MySidebar from "../../components/MySidebar/MySidebar";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const AddAnnouncement = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  return (
    <div className={s.addCar}>
      {width > 1000 ? <div className={s.top}>top</div> : null}
      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}

          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar />
              </div>
              <div className={s.announcements}>
                <Tabs type='card' className={s.tabs}>
                  <TabPane
                    tab={
                      <div>
                        <CarOutlined />
                        &nbsp; {`${t("add")} ${t("auto").toLowerCase()}`}
                      </div>
                    }
                    key='1'
                  >
                    <AddCar />
                  </TabPane>
                  <TabPane
                    tab={
                      <div>
                        <ToolOutlined />
                        &nbsp; {`${t("add")} ${t("spares").toLowerCase()}`}
                      </div>
                    }
                    key='2'
                  >
                    <AddSpares />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>
      <Footer />
    </div>
  );
};

export default AddAnnouncement;
